<template>
  <div class="dialog-wrapper">
    <div class="dialog-wrapper__popup">
      <h3 class="title">개인정보 처리방침 및 제3자 정보제공 동의</h3>
      <p class="sub-title">개인정보 수집 및 활용 약관 동의</p>
      <ol>
        <li>
          <p>수집하는 개인 정보의 항목</p>
          <ul>
            <li>수집 항목: 이름, 연락처, 선호지역, 성별, IP</li>
          </ul>
        </li>
        <li>
          <p>개인정보 수집 및 이용 목적</p>
          <ul>
            <li>이름, 연락처, 선호지역, 성별, IP : 이벤트 당첨 안내 및 본인 확인, 혜택정보 발송</li>
          </ul>
        </li>
        <li>
          <p>개인정보 보유 및 이용기간</p>
          <ul>
            <li>보유 기간 : 수집일로부터 3년</li>
          </ul>
        </li>
      </ol>
      <p class="sub-title">개인정보 취급 위탁 동의</p>
      <ol>
        <li>개인정보 처리 위탁을 받는 자 : 주식회사 펀다</li>
        <li>
          <p>위탁목적</p>
          <ul>
            <li>주식회사 펀다 : DB 서버 관리 및 운영</li>
          </ul>
        </li>
      </ol>
      <p class="sub-title">개인정보 처리방침 및 제3자 정보제공 동의 철회</p>
      <ol>
        <li>고객이 요청할 경우 언제든지 열람, 삭제를 요구할 수 있습니다.</li>
        <li>철회를 요청하시는 경우 철회 요청일로 부터 최대 영업일 기준 7일 이내에 기술적인 방법으로 복구 불가하도록 철회 및 삭제처리 됩니다.</li>
        <li>개인정보 관련 요청사항은 홈페이지의 고객센터를 통해 요청이 가능합니다.</li>
      </ol>
      <div class="button-block">
        <button v-ripple @click="$emit('close')" class="confirm-btn" type="submit">확인</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AgreementsDialog',
  props: ['isShow'],
  watch: {
    isShow(flag) {
      this.modalVisible(flag)
    }
  },
  data() {
    return {
    }
  },
  async created() {
    this.$emit('show')
  },
  destroyed() {
    this.modalVisible(false)
  },
  methods: {
    modalVisible(flag) {
      this.$store.commit('ui/modalVisible', flag)
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-wrapper {
  position: fixed;
  margin: 0;
  width: 100%;
  max-width: 42.5rem;
  height: 100%;
  z-index: 999;
  overflow-y: auto;
  ul, ol {
    padding-inline-start: 20px;
  }
  ol {
    font-size: 15px;
    line-height: 1.47;
    letter-spacing: -0.1px;
    color: #333333;
  }
  li{
    line-height: 25px;
  }
  &__popup {
    margin: 0 auto;
    position: relative;
    background-color: #ffffff;
    padding: 20px 10px;
    height: auto;
    animation: modal-popup-show 0.3s;
    .title {
      text-align: center;
      font-size: 18px;
      font-weight: 600;
    }
    .sub-title {
      font-size: 16px;
      font-weight: 600;
    }
    .notice-content {
      height: 190px;
    }

    h3 {
      font-size: 20px;
      font-weight: 900;
      margin-bottom: 16px;
    }

    button {
      outline: none;
      font-size: 18px;
      font-weight: 800;
      margin: 0;
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
      padding-top: 1rem;
      padding-bottom: 1rem;
      bottom: 0;
      z-index: 3;
    }
    .confirm-btn {
      color: #ffffff;
      background-color: rgb(51, 51, 51);
      right: 0;
      width: 100%;
    }
  }
}
@keyframes modal-popup-show {
  0% {
    transform: scale(0.7);
  }
  45% {
    transform: scale(1.05);
  }
  80% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
</style>
